import styled from "styled-components";
export const TargetHollTableStyle = styled.div``;
